export default {
  state: {
    mainAppIsLoaded: false,
    isMobile: false
  },
  mutations: {
    appLoaded(state) {
      state.mainAppIsLoaded = true;
    },
    setToMobile(state) {
      state.isMobile = true;
    },
    setToDesktop(state) {
      state.isMobile = false;
    }
  }
};
